export const SESSION_TIMEOUT_ROLES = ['superadmin', 'admin_taller', 'tecnico', 'cliente'] as const;

export type SessionTimeoutRole = (typeof SESSION_TIMEOUT_ROLES)[number];

export type SessionTimeoutSettings = {
  warningMinutes: number;
  roles: Record<SessionTimeoutRole, number>;
};

export const DEFAULT_SESSION_TIMEOUT_SETTINGS: SessionTimeoutSettings = {
  warningMinutes: 5,
  roles: {
    superadmin: 4 * 60,
    admin_taller: 8 * 60,
    tecnico: 6 * 60,
    cliente: 7 * 24 * 60,
  },
};

const clampMinutes = (value: unknown, fallback: number) => {
  const parsed = Number(value);
  if (!Number.isFinite(parsed)) return fallback;
  return Math.max(0, Math.min(Math.round(parsed), 7 * 24 * 60));
};

export const normalizeSessionTimeoutSettings = (raw?: unknown): SessionTimeoutSettings => {
  const source = raw && typeof raw === 'object' ? (raw as Record<string, any>) : {};
  const rolesSource = source.roles && typeof source.roles === 'object' ? source.roles : {};

  return {
    warningMinutes: clampMinutes(source.warningMinutes, DEFAULT_SESSION_TIMEOUT_SETTINGS.warningMinutes),
    roles: {
      superadmin: clampMinutes(rolesSource.superadmin, DEFAULT_SESSION_TIMEOUT_SETTINGS.roles.superadmin),
      admin_taller: clampMinutes(rolesSource.admin_taller, DEFAULT_SESSION_TIMEOUT_SETTINGS.roles.admin_taller),
      tecnico: clampMinutes(rolesSource.tecnico, DEFAULT_SESSION_TIMEOUT_SETTINGS.roles.tecnico),
      cliente: clampMinutes(rolesSource.cliente, DEFAULT_SESSION_TIMEOUT_SETTINGS.roles.cliente),
    },
  };
};

export const getSessionTimeoutForRole = (settings: SessionTimeoutSettings, role: SessionTimeoutRole | string | null | undefined) => {
  if (!role || !SESSION_TIMEOUT_ROLES.includes(role as SessionTimeoutRole)) return null;
  const minutes = settings.roles[role as SessionTimeoutRole];
  return minutes > 0 ? minutes : null;
};

export const formatSessionTimeout = (minutes: number) => {
  if (!minutes || minutes <= 0) return 'Desactivado';
  if (minutes % (24 * 60) === 0) {
    const days = minutes / (24 * 60);
    return `${days} día${days === 1 ? '' : 's'}`;
  }
  if (minutes % 60 === 0) {
    const hours = minutes / 60;
    return `${hours} hora${hours === 1 ? '' : 's'}`;
  }
  return `${minutes} min`;
};
